import React, { useState, useEffect } from "react";
import Select from "react-select";

export default function DuplicateableSelect(props) {
   const {
    label, value, onChange, data, placeholder, error, center, noMargin,
    theme,
    otherName,
    options,
    disable,
    displayValue,
    onRemove,
    onSelect,
    showCheckbox,
    param,
    values,
    ...others
  } = props;
  // const options = props.options || [];

  // selectedItems diset dari props.selected (dari backend)
  // const [selectedItems, setSelectedItems] = useState([]);
  const [currentSelect, setCurrentSelect] = useState(null);
  const selectedItems = values; 
  // Sync selectedItems jika props.selected berubah (misal data dari backend)
  // useEffect(() => {
  //   if (props.selected && Array.isArray(props.selected)) {
  //     setSelectedItems(props.selected);
  //   }
  // }, [props.selected]);

  const handleSelect = (option) => {
    if (!option) return;
    const updated = [...selectedItems, option];
    // setSelectedItems(updated);
    setCurrentSelect(null);
    // if (props.onChange) props.onChange(updated);
    if (onChange) onChange(updated);
  };

   const handleRemove = (indexToRemove) => {
    const updated = selectedItems.filter((_, index) => index !== indexToRemove);
    if (onChange) onChange(updated);
  };
  return (
    <div style={{ width: "100%", maxWidth: 400 }}>
      <Select
        options={options}
        onChange={handleSelect}
        values={currentSelect}
        placeholder="Pilih item"
        isSearchable
        styles={{
          control: (base, state) => ({
            ...base,
            boxShadow: "none",
            borderColor: state.isFocused ? "#ccc" : "#ccc",
            "&:hover": {
              borderColor: "#999",
            },
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "white" : state.isFocused ? "#f2f2f2" : "white",
            color: "black",
          }),
          singleValue: (base) => ({
            ...base,
            color: "black",
          }),
        }}
      />

     {selectedItems.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <strong>Selected Items:</strong>
          <ul style={{ paddingLeft: 20 }}>
            {selectedItems.map((item, index) => (
              <li key={index}>
                {item.label}{" "}
                <button
                  onClick={() => handleRemove(index)}
                  style={{ color: "red", marginLeft: 8, cursor: "pointer" }}
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
